module.exports = __webpack_public_path__ + "img/fast_logo1.9c0bfda9.png";